import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function ArrowDownIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...size !== undefined && { width: size, height: size }}
			{...props}
		>
			<path
				d="M4.70522 8.70473C5.09452 8.31543 5.72562 8.31519 6.11522 8.70419L11.9999 14.58L17.8847 8.70419C18.2743 8.31519 18.9054 8.31543 19.2947 8.70473C19.6842 9.09424 19.6842 9.72576 19.2947 10.1153L12.7071 16.7029C12.3165 17.0934 11.6834 17.0934 11.2928 16.7029L4.70522 10.1153C4.31571 9.72575 4.31571 9.09424 4.70522 8.70473Z"
				fill="currentColor"
			/>
		</svg>
	);
}

ArrowDownIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default ArrowDownIcon;
